import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { ContentModule } from 'app/layout/components/content/content.module';
import { FooterModule } from 'app/layout/components/footer/footer.module';
import { NavbarModule } from 'app/layout/components/navbar/navbar.module';
import { ToolbarModule } from 'app/layout/components/toolbar/toolbar.module';
import { LayoutComponent } from 'app/layout/layout.component';
import { SubscriptionBannerModule } from './components/subscription-banner/subscription-banner.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FuseSharedModule,
    ContentModule,
    FooterModule,
    NavbarModule,
    ScrollingModule,
    SubscriptionBannerModule,
    ToolbarModule,
    LayoutComponent,
  ],
  exports: [LayoutComponent],
})
export class LayoutModule {}
